import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../twc.refresh-layer-plugin.service';
import { WEATHER_TROPICAL_STORM_LEGEND } from './weather-tropical-storm.legend';
import { WEATHER_TROPICAL_STORM_PRODUCT_DATA } from './weather-tropical-storm.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class WeatherTropicalStormPluginService {
  private readonly _twcPluginService = inject(TwcRefreshLayerPluginService);

  plugin$ = this._twcPluginService.create(WEATHER_TROPICAL_STORM_PRODUCT_DATA, {
    legend: WEATHER_TROPICAL_STORM_LEGEND,
    twcLayerTypes: ['vector-tile']
  });
}
